import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Form, Alert } from "react-bootstrap";
import { Button } from "react-bootstrap";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { useUserAuth } from "../context/UserAuthContext";
import { auth } from "../firebase";
import Logo from "../assets/headerlogo.png";
import DesktopBg from "../assets/signin-bg-desktop.png";
import MobileBg from "../assets/signin-bg-mobile.png";
import { API_BASE_URL } from '../config';

const PhoneSignUp = () => {
  const [error, setError] = useState("");
  const [number, setNumber] = useState("");
  const [flag, setFlag] = useState(false);
  const [otp, setOtp] = useState("");
  const [result, setResult] = useState("");
  const { setUpRecaptha } = useUserAuth();
  const navigate = useNavigate();

  const getOtp = async (e) => {
    e.preventDefault();
    setError("");
    if (!number) return setError("Please enter a valid phone number!");
    try {
      const response = await setUpRecaptha(number);
      setResult(response);
      setFlag(true);
    } catch (err) {
      setError(err.message);
    }
  };

  const verifyOtp = async (e) => {
    e.preventDefault();
    setError("");
    if (!otp) return;
    try {
      await result.confirm(otp);
      const token = await auth.currentUser.getIdToken();

      const response = await fetch(`${API_BASE_URL}/user/${number}/verify`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
      });
      const data = await response.json();

      if (data && data.id) {
        navigate("/home", { state: { userData: data } });
      } else {
        throw new Error("User verification failed. Please try again.");
      }
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="phone-signup-container" style={{
      minHeight: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      color: "white",
      padding: "1rem",
      backgroundImage: `url(${DesktopBg})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat"
    }}>
      <div style={{
        backgroundColor: "#181F2A",
        borderRadius: "1rem",
        padding: "2rem",
        width: "100%",
        maxWidth: "400px",
        textAlign: "center",
        boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
        color: "black"
      }}>
        <img src={Logo} alt="Logo" style={{ height: 100, marginBottom: "1.5rem", marginTop: "1.5rem" }} />
        <h3 style={{ 
          fontFamily: "Halant", 
          marginBottom: ".8rem", 
          color: "white", 
          letterSpacing: '0.15rem', 
          fontSize: '2rem', 
          fontWeight: '500',
          textAlign: 'center',
          marginLeft: '20px'
        }}>
          isabel<sub style={{ fontSize: '0.6rem', verticalAlign: 'sub', marginLeft: '2px' }}>db</sub>
        </h3>
        {error && <Alert variant="danger">{error}</Alert>}

        <Form onSubmit={!flag ? getOtp : verifyOtp}>
          {!flag ? (
            <>
              <Form.Group className="mb-3">
                <PhoneInput
                  defaultCountry="US"
                  value={number}
                  onChange={setNumber}
                  style={{ width: '100%', background: 'transparent', border: 'none', color: 'white', marginTop: "2rem"}}
                  inputStyle={{ backgroundColor: 'transparent', color: 'white', border: 'none' }}
                  placeholder="Enter Phone Number"
                  className="custom-phone-input"
                />
                <div id="recaptcha-container"></div>
              </Form.Group>
              <Button
                type="submit"
                className="w-100"
                style={{ backgroundColor: "#F9AA33", borderColor: "#F9AA33", marginTop: "1rem"}}
              >
                Send OTP
              </Button>
            </>
          ) : (
            <>
              <Form.Group className="mb-3">
                <Form.Control
                  type="text"
                  placeholder="Enter OTP"
                  onChange={(e) => setOtp(e.target.value)}
                  style={{ marginTop: "1rem" }}
                />
              </Form.Group>
              <Button
                type="submit"
                className="w-100 mb-2"
                style={{ backgroundColor: "#F9AA33", borderColor: "#F9AA33" }}
              >
                Verify
              </Button>
              {error && (
                <Button
                  variant="secondary"
                  className="w-100"
                  onClick={() => {
                    setFlag(false);
                    setError("");
                    setOtp("");
                  }}
                >
                  Go Back
                </Button>
              )}
            </>
          )}
        </Form>
      </div>
      {/* Inline style override for react-phone-number-input */}
      <style>{`
        .custom-phone-input input {
          background-color: #181F2A;
          border: 1px solid #F9AA33;
          border-radius: 0.5rem;
          padding: 0.75rem;
          color: white;
          width: 100%;
        }
        .custom-phone-input input::placeholder {
          color: #ccc;
        }
        
        /* Responsive background images */
        @media (max-width: 767px) {
          .phone-signup-container {
            background-image: url(${MobileBg}) !important;
          }
        }
        @media (min-width: 768px) {
          .phone-signup-container {
            background-image: url(${DesktopBg}) !important;
          }
        }
      `}</style>
    </div>
  );
};

export default PhoneSignUp;